import customTheme from '@/constants/theme.custom';
import { FormControl } from '@chakra-ui/react';
import { Box, IconEdit, Input, Text } from '@cmpsr/components';
import { UseFormReturn } from 'react-hook-form';
import { PaymentFormState } from '../PPRAPaymentPage';
import { styleInput } from './styles';

export interface EmailSectionProps {
  email: string | null;
  isEmailEditable: boolean;
  setIsEmailEditable: (value: boolean) => void;
  form: UseFormReturn<PaymentFormState>;
  isPpraInviteRequired: boolean;
  inviteCode?: string | null;
  joinWaitlist?: () => void;
}

const EmailSection = ({
  email,
  isEmailEditable,
  setIsEmailEditable,
  form,
  inviteCode,
  joinWaitlist,
  isPpraInviteRequired,
}: EmailSectionProps) => (
  <Box width="100%" display="flex" flexDirection="column" gap="20px">
    <Text variant="text-header-XS" textTransform="uppercase">
      Account
    </Text>
    <Box>
      <Text
        color="#183344"
        fontSize="10px"
        fontFamily={customTheme.typography.fonts.inter}
        textTransform="uppercase"
        mb={2}
        as="label"
        htmlFor="email"
        id="email-label"
      >
        Email Address
      </Text>
      {isEmailEditable ? (
        <FormControl id="email" isInvalid={!!form.formState.errors.email}>
          <Input
            placeholder="Enter your email address"
            id="email"
            required
            {...form.register('email', {
              required: 'Email is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address',
              },
            })}
            onBlur={() => joinWaitlist && joinWaitlist()}
            {...styleInput}
          />
        </FormControl>
      ) : (
        <Box
          {...styleInput}
          display="flex"
          alignItems="center"
          p="4"
          role="textbox"
          aria-readonly="true"
          aria-labelledby="email-label"
        >
          <Text color="text-primary" flex={1} fontSize="14px" px={2}>
            {email}
          </Text>
          <IconEdit cursor="pointer" onClick={() => setIsEmailEditable(true)} color="#183344" aria-label="Edit email" />
        </Box>
      )}
      {form.formState.errors.email && (
        <Text color="salmon-light" fontSize="xs" mt={1}>
          {form.formState.errors.email.message}
        </Text>
      )}
    </Box>
    {isPpraInviteRequired && (
      <Box>
        <Text
          color="text-primary"
          fontSize="10px"
          fontFamily={customTheme.typography.fonts.inter}
          textTransform="uppercase"
          mb={2}
          as="label"
          htmlFor="inviteCode"
        >
          Invite Code
        </Text>
        <Input
          {...styleInput}
          placeholder="Enter your invite code"
          id="inviteCode"
          {...form.register('inviteCode', {
            required: isPpraInviteRequired ? 'Invite code is required' : false,
          })}
          onBlur={() => joinWaitlist && joinWaitlist()}
          defaultValue={inviteCode || ''}
        />
        {form.formState.errors.inviteCode && (
          <Text color="salmon-light" fontSize="xs" mt={1}>
            {form.formState.errors.inviteCode.message}
          </Text>
        )}
      </Box>
    )}
  </Box>
);

export default EmailSection;
